import { useSelector } from '@xstate/react';

import { useEssentialMachines } from '../../EssentialMachines';

// ─── AuthMachine Hook ───────────────────────────────────────────────────────────────────
export const useHasLoggedOut = () => {
  const { authMachineRef } = useEssentialMachines();

  const hasLoggedOut = useSelector(authMachineRef, (state) => {
    const { matches, history } = state;

    return matches('session.loggedOut') && history?.matches('session.loggedIn');
  });

  return Boolean(hasLoggedOut);
};
